import { MathNode } from "mathjs";

import { MATRIX_LATEX } from "../../generation/consts";
import { parseExpr } from "../../generation/operations";
import { getAsciiFromLatex } from "./getAsciiFromLatex";

export function parseLatexExpr(value: string): MathNode | string {
  // edge-case: if it's a matrix, then just return the original
  if (value.includes(MATRIX_LATEX)) {
    return value;
  }

  return parseExpr(getAsciiFromLatex(value));
}
